import { ColumnMappingDto } from "../../../types/admin/score-uploader/ColumnMappingDto";
import { IdentifierColumnType } from "../../../types/admin/score-uploader/IdentifierColumnType";
import { MappingOptionDto } from "../../../types/admin/score-uploader/MappingOptionDto";
import { ScoreMapping } from "../../../types/admin/score-uploader/ScoreMapping";
import { ScoreUploaderStep } from "../../../types/admin/score-uploader/ScoreUploaderStep";
import { UploadStatusResponse } from "../../../types/admin/score-uploader/UploadStatusResponse";
import ValidationResult from "../../../types/forms/ValidationResult";
import { dateHelper } from "../../../helpers";

export class ScoreUploaderState {
  currentStep: ScoreUploaderStep;
  // File data
  uploadedFile?: File;
  hasHeaderRow: boolean;
  totalRows?: number;
  dataDate: Date;
  // Column mapping data
  identifierColumn?: string;
  identifierType?: IdentifierColumnType;
  scoreMappings: ScoreMapping[];
  // API data
  isLoading: boolean;
  availableMappings?: MappingOptionDto[];
  suggestedMappings?: ColumnMappingDto[];
  uploadId?: string;
  uploadStatus?: UploadStatusResponse;
  validationResult: ValidationResult | null;
  showValidationErrors: boolean;
  error?: string;
  // State flags
  hasSuggestedMappingsBeenInitialized?: boolean;

  constructor(data: Partial<ScoreUploaderState> = {}) {
    this.currentStep = data.currentStep ?? ScoreUploaderStep.UploadFile;
    this.uploadedFile = data.uploadedFile;
    this.hasHeaderRow = data.hasHeaderRow ?? true;
    this.totalRows = data.totalRows;
    this.dataDate = data.dataDate ?? new Date();
    this.identifierColumn = data.identifierColumn;
    this.identifierType = data.identifierType;
    this.scoreMappings = data.scoreMappings ?? [];
    this.isLoading = data.isLoading ?? false;
    this.availableMappings = data.availableMappings;
    this.suggestedMappings = data.suggestedMappings;
    this.uploadId = data.uploadId;
    this.uploadStatus = data.uploadStatus;
    this.validationResult = data.validationResult ?? null;
    this.showValidationErrors = data.showValidationErrors ?? false;
    this.error = data.error;
    this.hasSuggestedMappingsBeenInitialized =
      data.hasSuggestedMappingsBeenInitialized;
  }

  // Computed property that automatically formats the date
  get dataDateString(): string | null {
    return dateHelper.convertDateObjectToServerString(this.dataDate) || null;
  }

  // Static method to create from existing instance or plain object (for object spread compatibility)
  static from(
    data: ScoreUploaderState | Partial<ScoreUploaderState>
  ): ScoreUploaderState {
    if (data instanceof ScoreUploaderState) {
      return new ScoreUploaderState(data);
    }
    return new ScoreUploaderState(data);
  }

  // Method to create a new instance with updated properties (maintains object spread compatibility)
  update(updates: Partial<ScoreUploaderState>): ScoreUploaderState {
    return new ScoreUploaderState({ ...this, ...updates });
  }

  // Method to convert to plain object for JSON serialization
  toJSON(): any {
    return {
      ...this,
      dataDateString: this.dataDateString || "", // Convert null to empty string for server
    };
  }
}
